/// <amd-module name="Pipeline/Analytics/DurationMetricsTrendCard/Actions/DurationMetricsTrendCardActionsCreator" />
import { IReportContext, Period } from "Analytics/Shared/Common/Types";
import { ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { DurationMetricsTrendCardActions } from "Pipeline/Analytics/DurationMetricsTrendCard/Actions/DurationMetricsTrendCardActions";
import { DurationMetricsTrendCardSource } from "Pipeline/Analytics/DurationMetricsTrendCard/Sources/DurationMetricsTrendCardSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class DurationMetricsTrendCardActionsCreator {
    private durationMetricsTrendCardSource: DurationMetricsTrendCardSource;

    constructor(private actions: DurationMetricsTrendCardActions, private pageContext: IVssPageContext) {
        this.durationMetricsTrendCardSource = new DurationMetricsTrendCardSource(pageContext);
    }

    public updateConfigurationValues(reportContext: IReportContext, newConfValues: ITrendChartReportConfiguration): Promise<void>[] {
        this.actions.updateConfigurationValuesAction.invoke(newConfValues);
        return [
            this.updateTrendChart(reportContext, newConfValues),
            this.updatePipelineDurationData(reportContext, newConfValues),
            this.updateInsightsData(reportContext, newConfValues)
        ];
    }

    private async updatePipelineDurationData(reportContext: IReportContext, confValues: ITrendChartReportConfiguration): Promise<void> {
        try {
            const pipelineDurationData = await this.durationMetricsTrendCardSource.queryPipelineDurationData(reportContext, confValues);
            this.actions.updatePipelineDurationDataAction.invoke(pipelineDurationData);
        } catch (error) {
            this.actions.onError.invoke(error);
            return Promise.reject(error);
        }
    }

    private async updateTrendChart(reportContext: IReportContext, newConfValues: ITrendChartReportConfiguration): Promise<void> {
        try {
            const chartData = await this.durationMetricsTrendCardSource.queryPipelineDurationTrendData(reportContext, newConfValues);
            this.actions.updateDataAction.invoke(chartData);
        } catch (error) {
            this.actions.onError.invoke(error);
            return Promise.reject(error);
        }
    }

    private async updateInsightsData(reportContext: IReportContext, newConfValues: ITrendChartReportConfiguration): Promise<void> {
        try {
            const insightsData = await this.durationMetricsTrendCardSource.getMaxDurationTaskData(reportContext, newConfValues);
            this.actions.updateInsightsDataAction.invoke(insightsData);
        } catch (error) {
            this.actions.onError.invoke(error);
            return Promise.reject(error);
        }
    }
}
